// store
import dataStore from '../../store/data.store';

const tenantStore = dataStore('tenant', {tenant: null});

export default tenantStore;
